import { useEffect, useState } from "react"
import { ProfilePage } from "./ProfilePage"
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../hooks/redux";

export const ProfileWithoutNavi = ()=>{
const profileId = useAppSelector(state=>state.appStore.profileId)
    return(
        
        profileId!=null?<ProfilePage userId={profileId}/>:<div></div>
    )
}